export const pluralizeString = (word: string, value: number) => {
  if (value <= 1) {
    return word;
  }
  return `${word}s`;
};

export const upCaseString = (inputStr: string) => {
  return inputStr.charAt(0).toUpperCase() + inputStr.slice(1);
};

//Truncates a string with '...' if it is longer than 30 characters
//Used by org-user-record and user-orgs-record
export const truncateString = (input: string) => {
  if (input.length > 30) {
    return input.slice(0, 25) + "...";
  } else {
    return input;
  }
};

// Maps template access values to user-friendly display strings
export const getTemplateAccessDisplayValue = (value: string): string => {
  switch (value) {
    case "open":
      return "All users (Conduct, edit)";
    case "full":
      return "All users (Conduct, edit, delete)";
    case "closed":
      return "Only the template creator";
    default:
      return "N/A";
  }
};
